/** @jsxImportSource @emotion/react */
'use client'
import { css } from '@emotion/react'
import Container from '@mui/material/Container'
import Image from 'next/image'
import Button from '../home/Button'
import { FlexRow } from '../layout'

interface HeaderProps {
	user: unknown
	onLoginClick: () => void
}

const styles = {
	contactBtn: css`
		display: none;

		@media (min-width: 768px) {
			display: inline-flex;
		}
	`,
	header: css`
		position: sticky;
		top: 0;
		z-index: 999;
		isolation: isolate;

		&::after {
			content: '';
			height: 150%;
			position: absolute;
			inset: 0;
			z-index: -1;
			pointer-events: none;
			background: linear-gradient(
				180deg,
				rgba(255, 255, 255, 1) 0%,
				rgba(255, 255, 255, 0) 100%
			);
			mask: linear-gradient(black, black, transparent);
			backdrop-filter: blur(8px);
		}
	`,
}


export default function Header({ user, onLoginClick }: HeaderProps) {
	return (
		<header
			css={styles.header}
		>
			<Container
				maxWidth={false}
				// biome-ignore lint/plugin: vertical inset of the page header band
				sx={{ py: 2 }}
			>
				<FlexRow justify="between">
					<Image
						src="/assets/images/WH-logo.png"
						alt="WyseHub logo"
						width="384"
						height="58"
						// biome-ignore lint/plugin: responsive logo dimensions on the next/image element
						style={{ maxWidth: 150, height: 'auto' }}
					/>
					<FlexRow>
						<Button
							variant="secondary"
							href="mailto:contact@wysehub.co.uk"
							css={styles.contactBtn}
						>
							Get in touch
						</Button>
						<Button variant="primary" onClick={onLoginClick}>
							Go to HomeHub
						</Button>
					</FlexRow>
				</FlexRow>
			</Container>
		</header>
	)
}
